const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20play%20button%20overlay%2C%20dramatic%20red%20and%20dark%20background%2C%20breaking%20news%20style%2C%20bold%20headline%20text%20area%2C%20modern%20media%20production%20aesthetic&width=600&height=360&seq=media-01&orientation=landscape',
    title: '独家深扒：某顶流男星感情时间线完整梳理',
    duration: '15:28',
    views: '256.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Video%20essay%20style%20thumbnail%20with%20dark%20dramatic%20cinematic%20look%2C%20investigative%20journalism%20theme%2C%20warm%20amber%20accents%20on%20black%20background%2C%20mysterious%20mood%2C%20documentary%20production%20style&width=600&height=360&seq=media-02&orientation=landscape',
    title: '选秀节目内幕大起底：谁在操控你的投票',
    duration: '22:15',
    views: '189.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=News%20report%20style%20video%20thumbnail%2C%20split%20screen%20design%20with%20dramatic%20contrast%2C%20dark%20crimson%20and%20black%20color%20scheme%2C%20entertainment%20scandal%20theme%2C%20professional%20media%20graphics&width=600&height=360&seq=media-03&orientation=landscape',
    title: '娱乐圈合约纠纷大盘点：天价违约金背后的故事',
    duration: '18:42',
    views: '143.5万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            视频瓜料
          </h2>
          <p className="text-foreground-500 text-sm">深度解说 · 沉浸式吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-white transition-colors">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 bg-black/70 text-white text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-3 leading-snug line-clamp-2 font-heading">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}